<div class="layout-topbar">
  <a class="layout-topbar-logo" routerLink="">
    <img
      src="assets/layout/images/{{
        layoutService.config().colorScheme === 'light' ? 'logo' : 'logo'
      }}.png"
      alt="logo"
    />
    <span>UVEMA</span>
  </a>

  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu"
    [ngClass]="{
      'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible
    }"
  >
    @if(iamService.isLoggedIn$ | async) {
    <p-button label="Cerrar sesión" (click)="iamService.logout()" onKeyPress="" />
    }
  </div>
</div>
